import { useEffect, useMemo } from "react";
import { Outlet, useParams, Navigate } from "react-router-dom";

type Normalized = "en" | "th" | "zh" | "zh-TW" | "ms" | "sg" | "invalid";

function normalize(seg?: string): Normalized {
  if (!seg) return "invalid";
  const lower = seg.toLowerCase();
  if (lower === "en") return "en";
  if (lower === "th") return "th";
  if (lower === "zh") return "zh";
  if (lower === "zh-tw") return "zh-TW";
  if (lower === "ms") return "ms";
  if (lower === "sg") return "sg";
  return "invalid";
}

export default function LangLayout() {
  const { lang } = useParams();
  const normalized = useMemo(() => normalize(lang), [lang]);

  useEffect(() => {
    // Map path segment to your i18n language keys.
    const map: Record<Exclude<Normalized, "invalid">, string> = {
      en: "en",
      th: "th",
      zh: "zh",
      "zh-TW": "zh-TW",
      ms: "ms",
      sg: "en-SG",
    };

    if (normalized !== "invalid") {
      const i18nLang = map[normalized];
      document.documentElement.setAttribute("lang", i18nLang);
      document.documentElement.setAttribute("dir", "ltr");
    }
  }, [normalized]);

  // If invalid language, redirect to home (RootRedirect will handle the language)
  if (normalized === "invalid") {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}